var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7907 21H8.2093C3.15814 21 1 18.8419 1 13.7907V8.2093C1 3.15814 3.15814 1 8.2093 1H13.7907C18.8419 1 21 3.15814 21 8.2093V13.7907C21 18.8419 18.8419 21 13.7907 21ZM8.2093 2.39535C3.92093 2.39535 2.39535 3.92093 2.39535 8.2093V13.7907C2.39535 18.0791 3.92093 19.6047 8.2093 19.6047H13.7907C18.0791 19.6047 19.6047 18.0791 19.6047 13.7907V8.2093C19.6047 3.92093 18.0791 2.39535 13.7907 2.39535H8.2093Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1744 14.9815C11.9976 14.9815 11.8209 14.9164 11.6813 14.7768L8.39764 11.4931C8.12787 11.2234 8.12787 10.7768 8.39764 10.5071L11.6813 7.22332C11.9511 6.95355 12.3976 6.95355 12.6674 7.22332C12.9372 7.49309 12.9372 7.9396 12.6674 8.20937L9.87669 11.0001L12.6674 13.7908C12.9372 14.0606 12.9372 14.5071 12.6674 14.7768C12.5372 14.9164 12.3604 14.9815 12.1744 14.9815Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.ad29869de0668a793b6dc6fe2c0d503a.svg";
export { ForwardRef as ReactComponent };